module.exports = "mutation ($data: TokenCreate!) {\n  TokenCreate(data: $data) {\n    id\n  }\n}\n"